module.exports = __webpack_public_path__ + "img/house.4392b297.png";